import React from 'react';
import ClickOutside from '../Utilities/ClickOutside';
import { configData } from '../Whitelabel/websitesData';
import { BrandsList } from '../Utilities/BrandsList';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const WhatsappDialog = ({ onClose, onSelect }) => {
    const handlePhoneClick = async (number) => {
        // Check if user is on mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        
        if (isMobile) {
            // Mobile behavior: trigger phone app
            const formattedNumber = number.replace(/\s/g, '');
            window.location.href = `tel:${formattedNumber}`;
        } else {
            // Desktop behavior: copy to clipboard
            try {
                // Check if Clipboard API is available
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(number);
                    toast.success('Número de telefone copiado');
                } else {
                    // Fallback for older browsers or if Clipboard API is not available
                    const textArea = document.createElement("textarea");
                    textArea.value = number;
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                    toast.success('Número de telefone copiado');
                }
            } catch (error) {
                console.error('Falha ao copiar número:', error);
                toast.error('Falha ao copiar número :(');
            }
        }
    };

    return (
        <div className='defaultDialog fadeIn'>
            {/* <ToastContainer 
                position="top-center" 
                autoClose={2000} // Automatically fades away after 2 seconds
                hideProgressBar={true} // No countdown
                closeOnClick 
                // pauseOnHover 
                // draggable 
                pauseOnFocusLoss 
                style={{ marginTop: '60px', zIndex: 999 }} // Top margin and z-index
            /> */}
            <ClickOutside onOutsideClick={onClose}>
                <div className='column cardFormContainer defaultDialogContainer' style={{ gap: '12px' }}>
                    <h2>Selecione o atendimento desejado:</h2>
                    {Object.entries(configData.multiContact).map(([key, number]) => {
                        const brandKeys = key.split('/').map(part => part.trim());
                        const handleClick = () => {
                            if (
                                    number === '11 4478 2465' ||
                                    number === '41 3021 4246' ||
                                    number === '41 3021 8981'

                                ) 
                            {
                                handlePhoneClick(number);
                            } else {
                                onSelect(number);
                            }
                        };

                        return (
                            <div key={key} className='whatsappOption clickArea' onClick={handleClick}>
                                {brandKeys.map(brandKey => {
                                    const brandLogo = BrandsList[brandKey.charAt(0).toUpperCase() + brandKey.slice(1)];
                                    return brandLogo ? <img key={brandKey} src={brandLogo} alt={`${brandKey} logo`} /> : null;
                                })}
                                <span>{key}</span>
                            </div>
                        );
                    })}
                </div>
            </ClickOutside>
        </div>
    );
};

export default WhatsappDialog;